// extracted by mini-css-extract-plugin
export var homewr = "home-module--homewr--85a02";
export var hsubtitle = "home-module--hsubtitle--10a0d";
export var htitle = "home-module--htitle--2a38a";
export var nd_headNodesk = "home-module--nd_head-nodesk--0be59";
export var nd_headNomob = "home-module--nd_head-nomob--933ed";